// useStore — React bindings for the vanilla Zustand store. A single store instance is created once
// and shared via context so all panels see the same working RuleSet + revision.
import { createContext, createElement, useContext, type ReactNode } from 'react';
import { useStore as useZustand } from 'zustand';
import { createStudioStore, type StudioStore, type StudioState } from './store';

const StoreContext = createContext<StudioStore | null>(null);

export function StudioProvider({ store, children }: { store?: StudioStore; children: ReactNode }) {
  const s = store ?? createStudioStore();
  return createElement(StoreContext.Provider, { value: s }, children);
}

export function useStudioStore<T>(selector: (s: StudioState) => T): T {
  const store = useContext(StoreContext);
  if (!store) throw new Error('useStudioStore must be used within <StudioProvider>');
  return useZustand(store, selector);
}

export function useStudioApi(): StudioStore {
  const store = useContext(StoreContext);
  if (!store) throw new Error('useStudioApi must be used within <StudioProvider>');
  return store;
}
